import AxiosService from '@/api/ApiBase';
import {
  IpiLoadGuideReceive,
  IpiLoadGuideReceivingFilters,
  IpiLoadReceivingResponse,
} from '@/types/ipi/load-guide/ipi.load-guide.types';
import { FilterOptionsParams } from '@/types/service/filters.service';
import { VirtualSearchPayload, VirtualSearchResponse } from '@/types/virtual-search';

const LOAD_GUIDE_BASE_URL = 'warehouse/ipi/loadGuide';

class IpiReceiveService {
  get(filters: IpiLoadGuideReceivingFilters) {
    return AxiosService.get<IpiLoadReceivingResponse>(`${LOAD_GUIDE_BASE_URL}/receive`, {
      params: filters,
    });
  }

  virtualSearch(payload: VirtualSearchPayload<IpiLoadGuideReceive>) {
    return AxiosService.post<VirtualSearchResponse<IpiLoadGuideReceive>>(
      'warehouse/v2/ipiReceiving/loadGuide/search',
      payload
    );
  }

  getNotViewedCount(code: string) {
    return AxiosService.get<{ count: number }>(`${LOAD_GUIDE_BASE_URL}/receive/count`, {
      params: { code },
    });
  }

  getFilterOptions<T>(params: Omit<FilterOptionsParams, 'limit'>) {
    return AxiosService.get<T>(`warehouse/ipi/receiving/filter/options`, {
      params: { ...params, limit: 100 },
    });
  }
}

export default new IpiReceiveService();
